import React  from "react";
import ErrorBoundary from "../components/ErrorBoundary";
import ErrorPage from "../pages/error/ErrorPage";
import Login from "../pages/login/Login";
import Home from "../pages/home/Home";
import Configuration from "../pages/configuration/Configuration";
import DetailConfiguration from "../pages/configuration/DetailConfiguration";
import Users from "../pages/users/Users";
import NewUser from "../pages/users/NewUser";
import EditUser from "../pages/users/EditUser";
import NewClient from "../pages/clients/NewClient";
import ClientDetail from "../pages/clients/ClientDetail";
import Formulario from "../pages/formulario/Formulario";
import FormularioVistaPrevia from "../pages/formulario-vista-previa/FormularioVistaPrevia";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Documentacion from "../pages/documentacion/Documentacion";
import Docs from "../pages/documentacion/Docs";
import Register from "../pages/register/Register";
import Activation from "../pages/register/Activation";
import LoginDoctor from "../pages/login-doctor/LoginDoctor";
import ForgotPassword from "../pages/password-reset/ForgotPassword";
import PasswordReset from "../pages/password-reset/PasswordReset";
import HomeDoctor from "../pages/doctor/home/HomeDoctor";
import MyInfoDoctor from "../pages/doctor/my-info/MyInfo";
import ResetMyPassDoctor from "../pages/doctor/reset-my-pass/ResetMyPass";
import MedicalStaff from "../pages/doctor/medical-staff/MedicalStaff";
import MedicalStaffProfile from "../pages/doctor/medical-staff-profile/MedicalStaffProfile";
import MyPrescriptions from "../pages/doctor/my-prescriptions/MyPrescriptions";
import MyPatients from "../pages/doctor/my-patients/MyPatients";
import NewPatient from "../pages/doctor/my-patients/NewPatient";
import ProfilePatient from "../pages/doctor/my-patients/ProfilePatient";
import EditPatient from "../pages/doctor/my-patients/EditPatient";
import NewPrescription from "../pages/doctor/my-prescriptions/NewPrescription";
import UserAuthRoute from "./UserAuthRoute";
import LogsVisualization from "../pages/logs-visualization/LogsVisualization";

export default function Routing({ state, role }) {
  return (
    <BrowserRouter
      basename={process.env.PUBLIC_URL ? process.env.PUBLIC_URL : ""}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ErrorBoundary>
      <Routes>
        {/* BACKOFFICE */}
        <Route element={<PrivateRoute allowedRole={[1, 2]} redirectPath="/backoffice" />}>
          <Route exact path="/medical-staff" element={<MedicalStaff />} />
          <Route exact path="/medical-staff/profile/:uId" element={<MedicalStaffProfile />}/>
        </Route>
        
        <Route element={<PrivateRoute allowedRole={[1]} redirectPath="/backoffice"  />}>
          <Route exact path="/users" element={<Users />} />
          <Route exact path="/users/new" element={<NewUser />} />
          <Route exact path="/users/edit/:userId" element={<EditUser />} />
          <Route exact path="/home" element={<Home />} />
          <Route exact path="/configuration" element={<Configuration />} />
          <Route exact path="/clients/new" element={<NewClient />} />
          <Route exact path="/clients/:clientId" element={<ClientDetail />} />
          <Route exact path="/documentacion" element={<Documentacion />} />
          <Route exact path="/configuration/:appId" element={<DetailConfiguration />}/>
          <Route exact path="/logs" element={<LogsVisualization />} />
          <Route exact path="/formulario-vista-previa/:appId" element={ <FormularioVistaPrevia basename={process.env.PUBLIC_URL ? process.env.PUBLIC_URL : ""}/>}/>
        </Route>
        
        <Route exact path="/backoffice" element={<Login />} />
        <Route exact path="/formulario/:hash" element={<Formulario />} />

        {/* MEDICO */}

        <Route element={ <UserAuthRoute routeState={state} allowedStates={["1", "0", "2", "3", "4"]} redirectPath="/" /> }>
          <Route path="/dashboard" element={<HomeDoctor />} />
          <Route path="/my-info" element={<MyInfoDoctor />} />
          <Route exact path="/reset-my-pass" element={<ResetMyPassDoctor />} />
        </Route>

        <Route element={ <UserAuthRoute allowedStates={["1"]} routeState={state} redirectPath="/"/>}>
          <Route exact path="/my-prescriptions/new" element={<NewPrescription />} />
          <Route exact path="/my-patients/edit/:idPaciente" element={<EditPatient />}/>
          <Route exact path="/my-patients/view/:idPaciente" element={<ProfilePatient />}/>
          <Route exact path="/my-patients" element={<MyPatients />} />
          <Route exact path="/my-patients/new" element={<NewPatient />} />
          <Route exact path="/my-prescriptions" element={<MyPrescriptions />} />
        </Route>

        <Route exact path="/" element={<LoginDoctor />} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route exact path="/password-reset/:token" element={<PasswordReset />} />
        <Route exact path="/register" element={<Register />} />
        <Route exact path="/activation/:token" element={<Activation />} />
        <Route exact path="/formulario/docs" element={<Docs />} />
        <Route path="/error" element={<ErrorPage />} />

      </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
